module.exports = __webpack_public_path__ + "static/media/workday.0ce5d8c5.jpg";